import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "col-lg-10 mx-lg-auto"
}
const _hoisted_6 = { class: "d-flex align-items-end" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = {
  key: 0,
  class: "lead text-preline"
}
const _hoisted_10 = {
  key: 0,
  alt: "",
  class: "ml-auto",
  height: "144",
  width: "150"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-4" }
const _hoisted_13 = { class: "col-lg-4 offset-lg-4" }
const _hoisted_14 = { class: "d-flex justify-content-end" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle text-primary message-icon mr-2" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "col-lg-10 mx-lg-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_Message = _resolveComponent("Message")!
  const _component_ProductAddedModal = _resolveComponent("ProductAddedModal")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "breadcrumbs")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.vm.availableInCurrentMarket)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.vm.title), 1),
                  (_ctx.vm.intro)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.vm.intro), 1))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.isSmallScreen)
                  ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_10, null, 512)), [
                      [_directive_lazy, '/Static/images/support.png']
                    ])
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_Card, null, {
                content: _withCtx(() => [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t("support.lblAmountOfTickets")), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.ticketAmount,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ticketAmount) = $event)),
                        "decrement-button-class": "p-button-outlined",
                        "increment-button-class": "p-button-outlined",
                        max: 100,
                        min: 0,
                        "show-buttons": "",
                        "use-grouping": false
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_PriceSummary, { vm: _ctx.priceSummary }, null, 8, ["vm"])
                    ])
                  ])
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Button, {
                      class: "p-button-success p-button-raised p-button-lg",
                      label: _ctx.$t('common.addToCart'),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addSupportTicketToCart()))
                    }, null, 8, ["label"])
                  ])
                ]),
                _: 1
              }),
              (_ctx.vm.supportSubscriptionText)
                ? (_openBlock(), _createBlock(_component_Message, {
                    key: 0,
                    class: "message-with-button my-3",
                    closable: false,
                    severity: "custom"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("span", null, _toDisplayString(_ctx.vm.supportSubscriptionText), 1)
                      ]),
                      (_ctx.vm.supportSubscriptionLinkItem)
                        ? (_openBlock(), _createBlock(_component_LinkButton, {
                            key: 0,
                            class: "p-button-success m-1",
                            label: _ctx.vm.supportSubscriptionLinkItem.text,
                            target: _ctx.vm.supportSubscriptionLinkItem.target,
                            title: _ctx.vm.supportSubscriptionLinkItem.title,
                            url: _ctx.vm.supportSubscriptionLinkItem.url
                          }, null, 8, ["label", "target", "title", "url"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_Message, {
                closable: false,
                severity: "error"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("common.productUnavailableInMarket")), 1)
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    (_ctx.cartStore.showProductAddedModal)
      ? (_openBlock(), _createBlock(_component_ProductAddedModal, {
          key: 0,
          vm: _ctx.productAddedVm
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}